import { useState, useCallback } from 'react'
import { toast } from 'react-toastify'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'

/**
 * Custom hook for uploading image files to server
 * Used after user confirms in preview modal
 */
export function useImageUpload() {
  const [isUploading, setIsUploading] = useState(false)

  const uploadImage = useCallback(async (file) => {
    if (!file) {
      toast.error('No file to upload')
      return null
    }

    setIsUploading(true)
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await postDataWithoutParams('/api/media/file/upload', formData)

      if (response?.status === 200) {
        return response.data.fileId
      } else {
        toast.error('Upload failed')
        return null
      }
    } catch (error) {
      toast.error('Something went wrong during upload')
      console.error('Upload error:', error)
      return null
    } finally {
      setIsUploading(false)
    }
  }, [])

  return {
    uploadImage,
    isUploading,
  }
}
